// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WishList_wrapper__g9xlk"};